import React from "react";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHeader";
import { PLANNING_TOOLS, PAGE_HEROES } from "../data/site";

export default function PlanningTools() {
  const hero = PAGE_HEROES.planning;
  return (
    <div data-testid="planning-tools-page" className="bg-[#f7f4ec]">
      <PageHero image={hero.image} title={hero.title} subtitle={hero.subtitle} testId="planning-hero" />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-24">
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {PLANNING_TOOLS.map((tool, i) => {
            const disabled = !tool.url || tool.url === "#";
            const Wrapper = disabled ? "div" : "a";
            const wrapperProps = disabled
              ? {}
              : { href: tool.url, target: "_blank", rel: "noreferrer noopener" };
            return (
              <li key={tool.name} data-testid={`planning-tool-${i}`}>
                <Wrapper
                  {...wrapperProps}
                  className={`surface-card rounded-md p-8 md:p-10 block ${
                    disabled ? "" : "hover:border-[#b8895a] transition-colors group"
                  }`}
                >
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <span className="font-serif text-base text-[#b8895a]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <h3 className="font-serif text-3xl md:text-4xl text-[#13263c] mt-2 leading-tight tracking-tight">
                        {tool.name}
                      </h3>
                      {tool.note && (
                        <p className="text-[0.62rem] uppercase tracking-[0.2em] text-[#737373] mt-2">
                          {tool.note}
                        </p>
                      )}
                      <p className="text-[#4a4a4a] leading-relaxed mt-4 max-w-md">
                        {tool.purpose}
                      </p>
                    </div>
                    {!disabled && (
                      <ArrowUpRight
                        size={26}
                        className="text-[#13263c] group-hover:text-[#b8895a] flex-shrink-0 mt-1 transition-colors"
                      />
                    )}
                  </div>
                </Wrapper>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
